import type { LevelCatalog, TrophyHall } from "@highmarch/app";
import type { HubApi } from "../../features/registry";

/**
 * How the Trophy Hall page reaches the game (features/trophyHall.ts sets it once at boot, like shopsLink.ts): the
 * Hall's use cases, the catalog, the clock and the hub. Null in tests and before boot: then the Shops screen shows no
 * Trophy Hall tab and `openTrophyHall` opens nothing.
 */
export interface TrophyLink {
  readonly hall: TrophyHall;
  readonly catalog: LevelCatalog;
  now(): number;
  /** Save and redraw the hub. */
  changed(): void;
  /** The hub while it is up (null in a level): the Hall opens only from the hub. */
  hub: HubApi | null;
}

let link: TrophyLink | null = null;
export function setTrophyLink(l: TrophyLink | null): void { link = l; }
export function trophyLink(): TrophyLink | null { return link; }
